import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./index.css";
import {
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  List,
  message,
  Row,
  Tabs,
  Typography,
} from "antd";
import { Link, useHistory } from "react-router-dom";
import { useQuery } from "../../../../hooks";
import I18n from "../../../../i18n";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../application/store";
import { loadUser } from "../../../../../application/user-slice";
import { Order } from "../../../../../domain";
import { DocumentTitle } from "../../../../components";
import moment from "moment-jalaali";
import { Endpoints, HttpClient } from "../../../../../infrastructure";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { addToCart } from "../../../../../application/cart-slice";
import { isMobile } from "react-device-detect";
import { ArrowRightOutlined } from "@ant-design/icons";

const { TabPane } = Tabs;

export default function Orders() {
  const query = useQuery();
  const history = useHistory();
  const activeTab = query.get("activeTab");
  const dispatch = useAppDispatch();
  const { loading, userInfo } = useAppSelector((state) => state.user);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadUser());
  }, [stableDispatch]);

  const onTabChange = (activeKey: string) =>
    history.push(`/profile/orders/?activeTab=${activeKey}`);

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const deleteOrder = async (id: string) => {
    try {
      setIsDeleteLoading(true);
      const hide = message.loading("در حال حذف سفارش...", 20);
      await ServiceLocater.get<HttpClient>(
        Services.HttpClinet
      ).delete(Endpoints.deleteOrder, { data: { id } });
      stableDispatch(loadUser());
      hide();
      setIsDeleteLoading(false);
      message.success("سفارش با موفقیت حذف شد.");
    } catch (error) {
      if (!error.response) setIsDeleteLoading(false);
      else setIsDeleteLoading(false);
      message.error(I18n.general.networkError);
    }
  };

  const payAgain = async (id: string) => {
    try {
      // save a copy
      const order = userInfo?.orders.find((order) => order.id === id);
      if (order === undefined) return;

      const hide = message.loading("در حال بارگذاری...");

      // delete previous
      setIsDeleteLoading(true);
      await ServiceLocater.get<HttpClient>(
        Services.HttpClinet
      ).delete(Endpoints.deleteOrder, { data: { id } });

      // add items to cart
      for (let index = 0; index < order.items.length; index++) {
        const item = order?.items[index];
        dispatch(
          addToCart({
            productId: item.product.id.toString(),
            attributeId: item.attribute.id,
            count: item.count,
            product: item.product,
          })
        );
      }
      hide();
      setIsDeleteLoading(false);
      history.push("/cart");
    } catch (error) {
      if (!error.response) setIsDeleteLoading(false);
      else setIsDeleteLoading(false);
      message.error(I18n.general.networkError);
    }
  };

  const renderOrderDetails = (order: Order) => {
    return (
      <div style={{ padding: "4px 0" }}>
        <div style={{ padding: 8 }}>
          <Typography.Text>آدرس دریافت: {order.addressString}</Typography.Text>
        </div>
        {order.items.map((item) => {
          return (
            <Link
              to={`/product/${item.product.id}/${encodeURIComponent(
                item.product.title
              )}`}
            >
              <Row
                align="middle"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #fafafa",
                }}
              >
                <Col xs={8}>
                  <img
                    src={item.product.images[0]}
                    alt={item.product.title}
                    width="100%"
                  />
                </Col>
                <Col xs={16} style={{ padding: "0 8px" }}>
                  <div>
                    <Typography.Text>{item.product.title}</Typography.Text>
                  </div>
                  <Row align="middle">
                    <Typography.Text>
                      سایز {item.attribute.size}
                      <div
                        style={{
                          height: 12,
                          width: 12,
                          borderRadius: 8,
                          marginLeft: 8,
                          marginRight: 8,
                          display: "inline-block",
                          backgroundColor: item.attribute.color.color,
                        }}
                      />
                      <Typography.Text>
                        {item.attribute.color.title}
                      </Typography.Text>
                    </Typography.Text>
                  </Row>
                  <div>
                    <Typography.Text>{item.count} عدد</Typography.Text>
                  </div>
                </Col>
              </Row>
            </Link>
          );
        })}
      </div>
    );
  };

  const renderOrder = (order: Order, index: number) => {
    return (
      <Card bodyStyle={{ padding: 0 }} style={{ marginBottom: 8 }}>
        <List.Item
          key={index}
          style={{ padding: 0 }}
          actions={[
            ...(isMobile
              ? []
              : [
                  <Dropdown
                    placement="bottomLeft"
                    overlay={
                      <div
                        className="header-menu-dropdown-overlay"
                        style={{
                          width: 300,
                          backgroundColor: "#fff",
                        }}
                      >
                        {renderOrderDetails(order)}
                      </div>
                    }
                  >
                    <Button type="link" size="small">
                      جزییات
                    </Button>
                  </Dropdown>,
                ]),
            ...(order.state === "PENDING"
              ? [
                  <Button
                    type="link"
                    size={isMobile ? "large" : "small"}
                    disabled={isDeleteLoading}
                    onClick={() => payAgain(order.id)}
                  >
                    پرداخت
                  </Button>,
                  <Button
                    type="link"
                    size={isMobile ? "large" : "small"}
                    danger
                    disabled={isDeleteLoading}
                    onClick={() => deleteOrder(order.id)}
                  >
                    حذف
                  </Button>,
                ]
              : []),
          ]}
        >
          <Col style={{ padding: 12 }}>
            <div className="order-info">
              {`کد سفارش: ${order.orderId} - ${moment
                .utc(order.date)
                .format("jYYYY-jMM-jDD")
                .replace(/-/g, "/")}`}
            </div>
            {order.state === "POSTED"
              ? `کد پیگیری پست: ${order.postalTrackingCode}`
              : ""}
            <Typography.Paragraph>
              مبلغ کل: {order.transaction.amount.toLocaleString()} تومان
            </Typography.Paragraph>
          </Col>
          {isMobile ? <Divider style={{ margin: 0 }} /> : <Fragment />}
          <Col>
            {isMobile ? (
              <Collapse bordered={false}>
                <Collapse.Panel key="1" header="جزییات">
                  {renderOrderDetails(order)}
                </Collapse.Panel>
              </Collapse>
            ) : (
              <Fragment />
            )}
          </Col>
        </List.Item>
      </Card>
    );
  };

  const isLoading = loading === "pending";
  return (
    <DocumentTitle title={I18n.profile.tabs.orders}>
      <Card bodyStyle={{ padding: 0 }}>
        <Row
          className={`orders-title${isMobile ? " orders-title-mobile" : ""}`}
          align="middle"
        >
          {isMobile ? (
            <Button
              style={{ marginLeft: 8 }}
              type="text"
              size="small"
              onClick={() => history.goBack()}
            >
              <ArrowRightOutlined />
            </Button>
          ) : (
            <Fragment />
          )}
          <div>{I18n.profile.tabs.orders}</div>
        </Row>
        <Tabs
          className="orders-tab-bar"
          tabPosition="top"
          defaultActiveKey={activeTab === null ? "pending" : activeTab}
          onChange={onTabChange}
        >
          <TabPane key="pending" tab="در اتنظار پرداخت">
            <List
              loading={isLoading}
              dataSource={userInfo?.orders.filter(
                (item) => item.state === "PENDING"
              )}
              renderItem={renderOrder}
            />
          </TabPane>
          <TabPane key="paid" tab="پرداخت شده">
            <List
              loading={isLoading}
              dataSource={userInfo?.orders.filter(
                (item) => item.state === "PAID"
              )}
              renderItem={renderOrder}
            />
          </TabPane>
          <TabPane key="posted" tab="پست شده">
            <List
              loading={isLoading}
              dataSource={userInfo?.orders.filter(
                (item) => item.state === "POSTED"
              )}
              renderItem={renderOrder}
            />
          </TabPane>
          <TabPane key="delivered" tab="تحویل شده">
            <List
              loading={isLoading}
              dataSource={userInfo?.orders.filter(
                (item) => item.state === "DELIVERED"
              )}
              renderItem={renderOrder}
            />
          </TabPane>
        </Tabs>
      </Card>
    </DocumentTitle>
  );
}
